import React from 'react';
import ReactGA from 'react-ga';
import { render } from 'react-snapshot';
import { BrowserRouter } from 'react-router-dom';
import App from 'components/App';
import ScrollToTop from 'components/ScrollToTop';
import initReactFastclick from 'react-fastclick';
import registerServiceWorker from 'registerServiceWorker';
import 'inobounce';

initReactFastclick();
ReactGA.initialize('UA-83207147-1');

render(
  <BrowserRouter>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </BrowserRouter>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js